/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
const CategorizerNavbarCtrl = function ($state, CategorizerRuleCollection) {
  this.rules = new CategorizerRuleCollection(this.rulesId);
};

module.exports = CategorizerNavbarCtrl;
